{
  "version": 1,
  "asset_id": "f0f25525-6f7d-4577-a099-68e3a4bdc592",
  "project_id": "bc28ec3a-38d3-4a78-848c-5618f322d6de",
  "url": "/__l5e/assets-v1/f0f25525-6f7d-4577-a099-68e3a4bdc592/timothy-ng-144.jpg",
  "r2_key": "a/v1/bc28ec3a-38d3-4a78-848c-5618f322d6de/f0f25525-6f7d-4577-a099-68e3a4bdc592/timothy-ng-144.jpg",
  "original_filename": "timothy-ng-144.jpg",
  "size": 5429,
  "content_type": "image/jpeg",
  "created_at": "2026-07-29T18:51:35Z"
}
